
import React from 'react';
import { withTranslation } from 'react-i18next/hooks';

import { Box, Button, TextField, FormControl, Select, MenuItem, InputLabel } from '@material-ui/core'; //Grid, Paper,

import DateFnsUtils from '@date-io/date-fns';
import {MuiPickersUtilsProvider, KeyboardDateTimePicker} from '@material-ui/pickers';
import { getDateTimeFormat } from '../../../../functions/lang';


class ReportCallRecordingFilter_ extends React.Component {

    constructor() {
        super()

        this.state = {

        }

        this.handleDateFromChange = this.handleDateFromChange.bind(this)
        this.handleDateToChange = this.handleDateToChange.bind(this)

        this.handleApplyFilter = this.handleApplyFilter.bind(this)
        this.handleAction = this.handleAction.bind(this)

    }

    handleDateFromChange(date){
        let filter = {...this.props.filter}
        filter.dateFrom = date
        console.log('handleDateFromChange')
        console.log(date)

        //this.setState({dateFrom: date})
        //if(this.props.onChange) this.props.onChange(filter)
        
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})
        
    }

    handleDateToChange(date){
        let filter = {...this.props.filter}
        //this.setState({dateTo: date})
        filter.dateTo = date
        console.log('handleDateToChange')
        console.log(date)

        //if(this.props.onChange) 
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})//
        
    }

    handleChange(e){
        console.log('handleChange event')
        console.log(e)

        let filter = {...this.props.filter}
        filter[e.target.name] = e.target.value
        this.props.onAction({type: 'FILTER_CHANGE', filter: filter})//
    }

    handleApplyFilter(){
        this.props.onAction({type:'FILTER_APPLY', filter: this.props.filter})
    }

    handleAction(action){

        switch(action.type){

            default: {
                alert(action.type)
            }

        }

    }


    render(){
        const {t, i18n} = this.props

        let dateFormat = getDateTimeFormat(i18n)

        const style = {
            select: {
                width: 150, 
                marginRight:10
            },
            label:{
                marginTop: 16,
                marginBottom: 8,
                display: 'inline-flex',
                lineHeight: '30px',
                marginRight: 5
            },
            datepicker:{
                width:180,
                marginRight: 16,
                marginTop: 0
            },
            textfield:{
                width: 120, 
                marginRight: 16,
                marginTop: 0
            },
            button:{
                //marginRight: 16,
                margin:8
            }
        }

        console.log('this.props.networks')
        console.log(this.props.networks)

        return(
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <Box style={{margin: '0 16px', paddingTop:8}}>

                <FormControl style={style.select}>
                    <InputLabel htmlFor="networkID">{t('Network')}</InputLabel>
                    <Select
                        label="network"
                        style={{textAlign: 'left'}}
                        value={this.props.filter.networkID}
                        onChange={this.handleChange.bind(this)}
                        inputProps={{name: 'networkID', id: 'networkID'}}
                        >
                        {this.props.networks.map(
                            network => <MenuItem key={network.ID} value={network.ID}>{network.Name}</MenuItem>
                        )}
                    </Select>
                </FormControl>

                <FormControl style={style.select}>
                    <InputLabel htmlFor="eventFilter">{t('CallType')}</InputLabel>
                    <Select
                        label="eventFilter"
                        style={{textAlign: 'left'}}
                        value={this.props.filter.eventFilter}
                        onChange={this.handleChange.bind(this)}
                        inputProps={{name: 'eventFilter', id: 'eventFilter'}}
                        >
                         <MenuItem key={0} value={0}>{t('AllVoiceCalls')}</MenuItem>
                         <MenuItem key={1} value={3}>{t('VoicePttGroup')}</MenuItem>
                         <MenuItem key={2} value={1}>{t('VoicePttPrivate')}</MenuItem>
                         <MenuItem key={3} value={12}>{t('VideoPttGroup')}</MenuItem>
                         <MenuItem key={4} value={11}>{t('VideoPttPrivate')}</MenuItem>
                    </Select>
                </FormControl>

  
                <KeyboardDateTimePicker
                    style={style.datepicker}
                    margin="normal"
                    id="dateFrom"
                    name="dateFrom"
                    label={t("From")}
                    cancelLabel={t('Cancel')}
                    okLabel={t('Apply')}
                    format={dateFormat}
                    value={this.props.filter.dateFrom}
                    onChange={this.handleDateFromChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />

                <KeyboardDateTimePicker
                    style={style.datepicker}
                    margin="normal"
                    id="dateTo"
                    name="dateTo"
                    label={t("To")}
                    cancelLabel={t('Cancel')}
                    okLabel={t('Apply')}
                    format={dateFormat}
                    value={this.props.filter.dateTo}
                    onChange={this.handleDateToChange}
                    KeyboardButtonProps={{
                        'aria-label': 'change date',
                    }}
                />

                
                <TextField 
                    name="search" 
                    margin='normal'
                    variant2="outlined"
                    size="small"
                    style={style.textfield}
                    label={t('Filter')}
                    autoComplete="new-password"
                    error={false}
                    value={this.props.filter.search}
                    onChange={this.handleChange.bind(this)}
                />

        
                <Button style={{margin:8}} 
                    variant="outlined" 
                    onClick={this.handleApplyFilter}>{t('Apply')}</Button>
            </Box>
            </MuiPickersUtilsProvider>
        );

    }

}

export const ReportCallRecordingFilter = withTranslation()(ReportCallRecordingFilter_);

